/*----------------------------------------------- NAV SECTION -----------------------------------------------*/
$(document).ready(function() {



// HEIGHTS CALCULATED FOR MOBILE MENU BOTTOM
function calcMobileNavHeights() {
  if ($(window).width() <= 768) {
    var navButtonHeight = 0;
    $("#header-3tandai nav .links [class*='button']").each(function(){
        navButtonHeight += $(this).outerHeight();
    });
 
    // HEIGHT (MOBILE-MENU-BOTTOM)
    var navWindowHeight = $(window).height();
    var navMobileMenuBottomHeight = navWindowHeight - navButtonHeight - 80;
    $('#header-3tandai nav .mobile-menu-bottom').css({ 'height' : navMobileMenuBottomHeight});

    // MIN-HEIGHT (NEED TO HAVE IN PLACE IF NO PROMO. IF THERE IS A PROMO, YOU CAN USE THIS BUT YOU DON'T NEED IT)
    var navMobileMenuBottomMinHeight = $('#header-3tandai nav .mobile-menu-bottom div').outerHeight() + 50;
    $('#header-3tandai nav .mobile-menu-bottom').css({'min-height' : navMobileMenuBottomMinHeight});  
  }
};


// CALL calcMobileNavHeights ON CLICK TAP OF BUTTON OR OR RESIZE
$("nav .links [class*='button']").on('click tap', function() {
  setTimeout(function(){ 
      calcMobileNavHeights();
  }, 410);
});

$(window).resize(function() {
      calcMobileNavHeights();
});







// // HAMBURGER
var hamburgerClickCount = 0
$('#header-3tandai nav .hamburger-3tandai').on('click tap', function() {
  hamburgerClickCount += 1;

  // ANIMATE HAMBURGER
  $('#header-3tandai nav .hamburger-3tandai div').toggleClass('animate');
  $('#header-3tandai nav .links').slideToggle( "normal" );

  // HIDE MENU IF EVEN NUMBER OF CLICKS
  if (hamburgerClickCount % 2 == 1) {
    $('body').css({'overflow':'hidden'});
  }

  if (hamburgerClickCount % 2 == 0) {
    $('#header-3tandai nav .menu').css({'display':'none'});
    $('#header-3tandai nav .menu-item-header').removeClass( "menu-item-header-highlight" );
    $('#header-3tandai nav .menu-item-header span:first-of-type').removeClass('nav-plus-minus-rotate');
    $('body').css({'overflow':'scroll'});
  }

  if (hamburgerClickCount % 2 == 1) {
    if ($(window).width() <= 768) {
	  // TIMEOUT IS ONLY FOR WHEN WE WANT PRODUCTS TO AUTOMATICALLY OPEN ON HAMBURGER CLICK
      setTimeout(function(){ 
          calcMobileNavHeights();
      }, 410);
    }
  }

  // AUTOMATICALLY OPENS PRODUCTS MENU ON HAMBURGER CLICK
  if (hamburgerClickCount % 2 == 1) {
    $("#header-3tandai nav [class*='button']:first-of-type .menu").slideToggle( "normal" );
    $("#header-3tandai nav [class*='button']:first-of-type .menu-item-header").addClass( "menu-item-header-highlight" );
    $("#header-3tandai nav [class*='button']:first-of-type .menu-item-header span:first-of-type").toggleClass('nav-plus-minus-rotate');
  }
})







// THINGS TO DO ON RESIZE 
$(window).resize(function() {

  if ($(window).width() <= 768) {
    $(window).resize(function() {
      if ($(window).width() >= 769) {
        $('#header-3tandai nav .links').css({'display':'flex'}); 
        $('#header-3tandai nav .menu').css({ 'display' : 'block'});
        $('#header-3tandai nav .hamburger-3tandai div').removeClass('animate');
        $('body').css({'overflow':'scroll'});

        if (hamburgerClickCount % 2 == 1) {
          hamburgerClickCount += 1;
        }

      }
    });
  }

  if ($(window).width() >= 769) {
    $(window).resize(function() {
      if ($(window).width() <= 768) {
        $('#header-3tandai nav .menu').css({ 'display' : 'none'});
        $('#header-3tandai nav .menu-item-header').removeClass( "menu-item-header-highlight" );
        $('#header-3tandai nav .menu-item-header span:first-of-type').removeClass( "nav-plus-minus-rotate" );

        if (hamburgerClickCount % 2 == 1) {
          $('#header-3tandai nav .links').css({'display':'block'}); 
        }
        if (hamburgerClickCount % 2 == 0) {
          $('#header-3tandai nav .links').css({'display':'none'});
        }
      }
    });
  }

});







// MOBILE HIDE/SHOW MENUS
$("#header-3tandai nav [class*='button']").on('click tap', function() {
  if ($(window).width() <= 768) {
    $(this).find('.menu').slideToggle( "normal" );
    $(this).siblings().find('.menu').slideUp( "normal" );

    $(this).find('.menu-item-header span:first-of-type').toggleClass('nav-plus-minus-rotate');
    $(this).siblings().find('.menu-item-header span:first-of-type').removeClass( "nav-plus-minus-rotate" );
  }
})

// MOBILE HIGHLIGHTS MENU-ITEM-HEADER
$('#header-3tandai nav .button-multiple-items').on('click tap', function() {
  if ($(window).width() <= 768) {
    $(this).find('.menu-item-header').toggleClass('menu-item-header-highlight');
    $(this).siblings().find('.menu-item-header').removeClass( "menu-item-header-highlight" );
  }
});



});
/*----------------------------------------------- NAV SECTION (END) -----------------------------------------------*/


